import React from 'react';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import { ThemeProvider as MUIThemeProvider } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

export const ThemeProvider: React.FC<{ theme: Theme }> = ({
  children,
  theme,
}) => (
  <EmotionThemeProvider theme={theme}>
    <MUIThemeProvider theme={theme}>{children}</MUIThemeProvider>
  </EmotionThemeProvider>
);
